import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const baseProps = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

export const CaloriesIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <g clipPath="url(#nutrition_calories_clip)">
      <path
        d="M13.9798 23.4794C13.8402 23.2992 13.754 23.0834 13.7312 22.8567C13.7084 22.6299 13.7498 22.4012 13.8508 22.1969C14.1148 21.6839 14.2183 21.0974 14.1508 20.5199C14.0957 20.1078 13.9596 19.7106 13.7503 19.3514C13.5448 18.9961 13.2686 18.6867 12.9388 18.4424C11.8173 17.5995 11.0303 16.3869 10.7173 15.0194C8.15529 18.3779 9.13779 20.2844 10.3648 21.9644C10.5082 22.1615 10.5837 22.3999 10.5799 22.6436C10.5761 22.8874 10.4932 23.1233 10.3438 23.3159C10.191 23.5106 9.98605 23.6578 9.75279 23.7404C9.52219 23.8212 9.27308 23.8332 9.03579 23.7749C7.37829 23.3699 5.81829 22.5989 4.76079 21.3704C4.16177 20.6877 3.70031 19.8957 3.40179 19.0379C3.09996 18.1727 2.96606 17.2578 3.00729 16.3424C3.00729 16.3424 2.80779 12.6479 7.26279 9.02839C7.26279 9.02839 12.5278 4.56139 10.7008 1.25839C10.6333 1.09595 10.6132 0.917697 10.643 0.744321C10.6727 0.570945 10.751 0.409558 10.8688 0.278893C10.9834 0.151053 11.1344 0.0613854 11.3014 0.0219622C11.4685 -0.017461 11.6437 -0.00474679 11.8033 0.0583931L12.0223 0.145393C14.0054 1.39895 15.5554 3.23168 16.4623 5.39539C17.3323 7.51489 17.3263 9.98539 16.7383 12.1859C17.2258 11.7479 17.6323 11.2244 17.9398 10.6364L17.9833 10.5404C18.2803 9.82489 19.2148 10.0529 19.5658 10.5209C19.6948 10.7264 23.0038 15.5354 21.2263 19.5929C20.5773 20.8228 19.6278 21.8687 18.4663 22.6334C17.4927 23.2807 16.4041 23.7354 15.2593 23.9729C15.0228 24.023 14.7767 24.0032 14.5513 23.9159C14.3239 23.8272 14.1259 23.6765 13.9798 23.4809V23.4794ZM11.3308 11.8379C11.4707 11.7642 11.6332 11.7458 11.786 11.7864C11.9389 11.827 12.0709 11.9235 12.1558 12.0569C12.2158 12.1469 12.2533 12.2459 12.2683 12.3539L12.3358 12.8774C12.3658 13.6439 12.3568 14.4449 12.6553 15.1814C12.9643 15.9374 13.4443 16.6064 14.0533 17.1284C14.8379 17.6446 15.4452 18.3891 15.7933 19.2614C16.1233 20.1074 16.1683 21.0464 15.9193 21.9209C16.6814 21.6814 17.3896 21.2957 18.0043 20.7854L18.1588 20.6594C18.6628 20.2439 19.0783 19.7249 19.3783 19.1339C19.6798 18.5444 19.8613 17.8964 19.9093 17.2304C20.0068 15.6929 19.4833 14.1494 18.6688 12.7724C18.2968 13.3124 17.7838 13.7309 17.1913 13.9784C16.8208 14.1359 16.4278 14.2334 16.0273 14.2634C15.798 14.2775 15.5694 14.2254 15.3688 14.1134C15.1652 13.9979 14.9984 13.8274 14.8873 13.6214C14.7958 13.4552 14.7435 13.2702 14.7344 13.0807C14.7253 12.8912 14.7596 12.7021 14.8348 12.5279C15.4528 11.0699 15.6448 9.45289 15.3823 7.88239C15.0719 6.08547 14.2113 4.42923 12.9193 3.14239C12.6853 6.44989 9.29379 9.52939 8.59779 10.1924C8.48942 10.2935 8.37735 10.3906 8.26179 10.4834C4.62279 13.4309 4.87179 16.1159 4.87179 16.2344C4.80143 17.3009 5.0405 18.365 5.56029 19.2989C6.10779 20.2664 6.89529 21.0644 7.84029 21.6089C6.74979 19.2119 6.74979 16.3349 10.7743 12.2099L11.3323 11.8349L11.3308 11.8379Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="nutrition_calories_clip">
        <rect width="24" height="24" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProteinIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <g clipPath="url(#nutrition_protein_clip)">
      <path
        d="M12 21C10.05 21 8.396 20.321 7.038 18.963C5.68 17.605 5.00067 15.9507 5 14C5 12.7167 5.21267 11.425 5.638 10.125C6.06333 8.825 6.61333 7.646 7.288 6.588C7.96267 5.53 8.71667 4.66733 9.55 4C10.3833 3.33267 11.2 2.99933 12 3C12.8167 3 13.6377 3.33333 14.463 4C15.2883 4.66667 16.0383 5.52933 16.713 6.588C17.3877 7.64667 17.9377 8.82567 18.363 10.125C18.7883 11.4243 19.0007 12.716 19 14C19 15.95 18.321 17.6043 16.963 18.963C15.605 20.3217 13.9507 21.0007 12 21ZM12 19C13.3833 19 14.5627 18.5123 15.538 17.537C16.5133 16.5617 17.0007 15.3827 17 14C17 13.05 16.8373 12.05 16.512 11C16.1867 9.95 15.7783 8.97933 15.287 8.088C14.7957 7.19667 14.2583 6.459 13.675 5.875C13.0917 5.291 12.5333 4.99933 12 5C11.4833 5 10.9293 5.29167 10.338 5.875C9.74667 6.45833 9.205 7.196 8.713 8.088C8.221 8.98 7.81267 9.95067 7.488 11C7.16333 12.0493 7.00067 13.0493 7 14C7 15.3833 7.48767 16.5627 8.463 17.538C9.43833 18.5133 10.6173 19.0007 12 19ZM13 18C13.2833 18 13.521 17.904 13.713 17.712C13.905 17.52 14.0007 17.2827 14 17C13.9993 16.7173 13.9033 16.48 13.712 16.288C13.5207 16.096 13.2833 16 13 16C12.1667 16 11.4583 15.7083 10.875 15.125C10.2917 14.5417 10 13.8333 10 13C10 12.7167 9.904 12.4793 9.712 12.288C9.52 12.0967 9.28267 12.0007 9 12C8.71733 11.9993 8.48 12.0953 8.288 12.288C8.096 12.4807 8 12.718 8 13C8 14.3833 8.48767 15.5627 9.463 16.538C10.4383 17.5133 11.6173 18.0007 13 18Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="nutrition_protein_clip">
        <rect width="24" height="24" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CarbsIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <g clipPath="url(#nutrition_carbs_clip)">
      <path
        d="M18.0001 4C18.6074 4.00024 19.2004 4.18481 19.7006 4.52931C20.2008 4.8738 20.5846 5.362 20.8014 5.92934C21.0181 6.49669 21.0576 7.11645 20.9145 7.7067C20.7714 8.29695 20.4526 8.82987 20.0001 9.235V18C20.0001 18.5304 19.7894 19.0391 19.4143 19.4142C19.0392 19.7893 18.5305 20 18.0001 20H6.0001C5.46967 20 4.96096 19.7893 4.58589 19.4142C4.21082 19.0391 4.0001 18.5304 4.0001 18V9.236C3.55839 8.84096 3.24357 8.32395 3.09536 7.7502C2.94714 7.17644 2.97216 6.57164 3.16727 6.01209C3.36238 5.45254 3.71884 4.96331 4.19167 4.60611C4.6645 4.24891 5.23253 4.03974 5.8241 4.005H18.0001V4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="nutrition_carbs_clip">
        <rect width="24" height="24" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FatIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <g clipPath="url(#nutrition_fat_clip)">
      <path
        d="M4.19724 19.7895C3.8649 19.4572 3.57499 19.0965 3.32043 18.7006C1.36882 15.6883 2.23856 11.6648 5.25083 9.71323C6.262 9.05562 7.43579 8.70207 8.63787 8.67379C8.87594 8.66749 9.10251 8.57011 9.2709 8.40172C9.4393 8.23333 9.53668 8.00675 9.54297 7.76869C9.89652 4.47357 12.8522 2.08355 16.1473 2.43711C19.4425 2.79066 21.8275 5.75132 21.4719 9.04855C21.1749 11.8487 18.9687 14.0549 16.1473 14.3731C15.6524 14.4579 15.2776 14.8893 15.2705 15.3913C15.1503 18.9763 12.1451 21.7977 8.55302 21.6704C6.91464 21.6206 5.35689 20.948 4.19724 19.7895ZM18.3394 5.64737C17.6959 5.0039 16.8474 4.59378 15.9423 4.50893C15.4211 4.44987 14.8934 4.4944 14.3895 4.63998C13.8856 4.78556 13.4154 5.02931 13.006 5.35722C12.5966 5.68512 12.2561 6.09071 12.004 6.55067C11.7519 7.01063 11.5932 7.51589 11.537 8.03739C11.4097 9.52232 10.1652 10.6678 8.66616 10.6961C6.18421 10.7739 4.23967 12.8599 4.31745 15.3418C4.39523 17.8237 6.47413 19.7754 8.96314 19.6905C10.1045 19.6527 11.1888 19.1825 11.9963 18.375C12.8038 17.5675 13.2741 16.4832 13.3118 15.3418C13.3191 14.603 13.5987 13.8928 14.0972 13.3474C14.5956 12.802 15.2778 12.4597 16.013 12.3861C17.0667 12.2693 18.031 11.739 18.694 10.9117C19.3569 10.0843 19.6643 9.0276 19.5485 7.97375C19.4637 7.3515 19.2798 6.78581 18.9616 6.26962L18.3394 5.64737ZM16.2181 7.76869C15.8291 8.1576 15.8291 8.794 16.2181 9.1829C16.607 9.57181 17.2434 9.57181 17.6323 9.1829C18.0212 8.794 18.0212 8.1576 17.6323 7.76869C17.2434 7.37978 16.607 7.37978 16.2181 7.76869ZM8.43988 18.3753C8.82879 18.7642 9.46519 18.7642 9.8541 18.3753C10.243 17.9864 10.243 17.35 9.8541 16.9611C9.46519 16.5722 8.82879 16.5722 8.43988 16.9611C8.05098 17.35 8.05098 17.9864 8.43988 18.3753ZM9.8541 15.5469C10.243 15.9358 10.8794 15.9358 11.2683 15.5469C11.6572 15.158 11.6572 14.5216 11.2683 14.1327C10.8794 13.7437 10.243 13.7437 9.8541 14.1327C9.46519 14.5216 9.46519 15.158 9.8541 15.5469ZM7.02567 15.5469C7.41458 15.9358 8.05098 15.9358 8.43988 15.5469C8.82879 15.158 8.82879 14.5216 8.43988 14.1327C8.05098 13.7437 7.41458 13.7437 7.02567 14.1327C6.63676 14.5216 6.63676 15.158 7.02567 15.5469Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="nutrition_fat_clip">
        <rect width="24" height="24" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FiberIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <path
      d="M14.3384 8.80371L7.21338 21.1446"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5663 18.8944C11.2244 19.2539 9.081 18.1811 9.081 18.1811C9.081 18.1811 10.4286 15.7833 11.9303 15.496C13.2564 15.2424 15.2281 16.534 15.2281 16.534C15.2281 16.534 13.9083 18.5348 12.5663 18.8944Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5678 13.6956C14.2258 14.0552 12.0825 12.9824 12.0825 12.9824C12.0825 12.9824 13.43 10.5846 14.9317 10.2973C16.2579 10.0436 18.2296 11.3353 18.2296 11.3353C18.2296 11.3353 16.9098 13.336 15.5678 13.6956Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3073 6.84352C16.6127 8.0467 14.3385 8.8037 14.3385 8.8037C14.3385 8.8037 13.5958 6.15531 14.4546 4.8903C15.2129 3.77321 17.5205 3.29234 17.5205 3.29234C17.5205 3.29234 18.002 5.64033 17.3073 6.84352Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.3958 15.3318C6.75539 16.6737 8.75614 17.9936 8.75614 17.9936C8.75614 17.9936 10.1589 15.6276 9.65686 14.1835C9.21349 12.9082 7.10903 11.8464 7.10903 11.8464C7.10903 11.8464 6.03622 13.9898 6.3958 15.3318Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.39727 10.133C9.75685 11.475 11.7576 12.7948 11.7576 12.7948C11.7576 12.7948 13.1604 10.4289 12.6583 8.98472C12.215 7.70943 10.1105 6.64771 10.1105 6.64771C10.1105 6.64771 9.03769 8.79107 9.39727 10.133Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SodiumIcon: React.FC<IconProps> = (props) => (
  <svg {...baseProps} {...props}>
    <rect
      x="12"
      y="2.08511"
      width="14.0219"
      height="14.0219"
      rx="2"
      transform="rotate(45 12 2.08511)"
      stroke="currentColor"
      strokeWidth="2"
    />
    <rect
      x="7.19434"
      y="7.19238"
      width="10.1749"
      height="10.1749"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
